import { API_POLLING_INTERVAL_MS } from "@auth/definitions"
import { authProvider, firebaseAuth } from "@auth/firebase"
import { apiJWTAtom } from "@auth/state"
import { gAPI } from "data/gapi"
import { client } from "data/hasura"
import { useGoogleAccessToken } from "hooks/google/useGoogleAccessToken"
import { useSetAtom } from "jotai"
import { useEffect } from "react"

export const RefreshTokens = () => {
    const setT = useSetAtom(apiJWTAtom)
    const { accessToken } = useGoogleAccessToken()

    if (accessToken) {
        gAPI.client?.setToken({ access_token: accessToken })
        // logger.debug("refreshed GAPI token!")
    }

    useEffect(() => {
        const f = async () => {
            const token = await firebaseAuth.auth.currentUser?.getIdToken()
            // logger.debug(token)
            if (token) {
                client.setHeader('Authorization', `Bearer ${token}`)
                setT(token)
                // logger.debug("refreshed API token!")
            }
        }
        const inter = setInterval(f, API_POLLING_INTERVAL_MS)
        f()
        return () => {
            clearInterval(inter)
        }
    }, [])

    return <></>
}
